import { useEffect, useState } from 'react';
import { isOutdated } from '../utils/appUpdate';

const CHECK_EVERY_MS = 5 * 60 * 1000;

// true cuando ya hay publicada una versión más nueva que la que está corriendo. Se revisa al abrir, cada 5 minutos y al volver a la pestaña.
export const useAppUpdate = () => {
  const [outdated, setOutdated] = useState(false);
  useEffect(() => {
    let alive = true;
    const check = async () => {
      if (await isOutdated() && alive) setOutdated(true);
    };
    const first = setTimeout(check, 15000);
    const every = setInterval(check, CHECK_EVERY_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { alive = false; clearTimeout(first); clearInterval(every); document.removeEventListener('visibilitychange', onVisible); };
  }, []);
  return outdated;
};
